<template>
  <a class="close" href="javascript:void(0);" role="button">
    <svg
      width="18px"
      height="17px"
      viewBox="0 0 18 17"
      version="1.1"
      title="Close"
      alt="Close"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" stroke-width="1">
        <path
          d="M8.99734389,7.08578644 L16.0684117,0.0147186258 L17.4826253,1.42893219 L10.4115575,8.5 L17.5536931,15.6421356 L16.1394795,17.0563492 L8.99734389,9.91421356 L1.92627608,16.9852814 L0.512062518,15.5710678 L7.58313033,8.5 L0.58313033,1.5 L1.99734389,0.0857864376 L8.99734389,7.08578644 Z"
        ></path>
      </g>
    </svg>
  </a>
</template>

<script>
export default {};
</script>
